export default __webpack_public_path__ + "static/media/close.3de7462a.svg";